import { Directive, HostListener } from '@angular/core'
import { AuthFacadeService } from '../services/auth-facade.service'

@Directive({
  selector: '[jmlGlobalClick]'
})
export class GlobalClickDirective {
  constructor(private userService: AuthFacadeService) {}

  @HostListener('document:click', ['$event'])
  click(event: Event) {
    this.userService.userIsActive()
  }

  @HostListener('document:keydown', ['$event'])
  keydown(event: KeyboardEvent) {
    this.userService.userIsActive()
  }

  @HostListener('document:mousemove', ['$event'])
  mousemove(event: MouseEvent) {
    this.userService.userIsActive()
  }
}
